import React, { useEffect, useState } from "react";
import axios from "axios";

export default function WorkoutViewModal({
  workoutId,
  isOpen,
  onClose,
  onEdit,
  onDuplicate,    // ⬅️ NEW PROP
}) {
  const [loading, setLoading] = useState(false);
  const [workout, setWorkout] = useState(null);

  useEffect(() => {
    if (!isOpen || !workoutId) return;
    (async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const { data } = await axios.get(`/api/workouts/${workoutId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWorkout(data);
      } catch (e) {
        console.error("Failed to load workout:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [isOpen, workoutId]);

  // 🔹 NEW: duplicate handler inside the modal
  const handleDuplicate = async () => {
    if (!workoutId) return;
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `/api/workouts/${workoutId}/duplicate`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (onDuplicate) onDuplicate(data); // notify parent
      onClose(); // close view modal
    } catch (err) {
      console.error("Failed to duplicate workout:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[85vh] overflow-y-auto relative p-6">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-700 hover:text-black text-2xl font-bold"
        >
          ✕
        </button>

        <h2 className="text-lg font-bold mb-4">
          {workout
            ? new Date(workout.date).toLocaleDateString("en-US", {
                weekday: "long",
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "Workout"}
        </h2>

        {loading && <div className="text-sm text-gray-600">Loading…</div>}

        {!loading && workout && (
          <>
            <div className="space-y-4">
              {workout.exercises.map((ex, idx) => (
                <div key={idx} className="border rounded-lg p-4">
                  <div className="font-semibold mb-2">{ex.name}</div>
                  <div className="grid grid-cols-3 text-sm font-semibold text-gray-700 mb-2">
                    <span>Set</span>
                    <span className="text-center">lbs</span>
                    <span className="text-center">Reps</span>
                  </div>
                  <div className="space-y-1">
                    {ex.sets.map((s, sIdx) => (
                      <div
                        key={sIdx}
                        className="grid grid-cols-3 items-center text-sm"
                      >
                        <div>{sIdx + 1}</div>
                        <div className="text-center">{s.lbs}</div>
                        <div className="text-center">{s.reps}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Buttons footer */}
            <div className="mt-6 flex justify-end gap-3">
              {onEdit && (
                <button
                  onClick={() => onEdit(workout)}
                  className="px-4 py-2 rounded-md bg-[#e53935] text-white hover:bg-black text-sm"
                >
                  Edit Workout
                </button>
              )}

              {/* 🔹 NEW Duplicate button */}
              {onDuplicate && (
                <button
                  onClick={handleDuplicate}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 text-sm"
                >
                  Duplicate
                </button>
              )}
            </div>
          </>
        )}

        {!loading && !workout && (
          <div className="text-sm text-gray-600">No data.</div>
        )}
      </div>
    </div>
  );
}